<script>
import { mapActions } from 'vuex'

export default {
   name: 'ScrapConfigModal',
   props: {
      value: {
         type: Boolean,
         default: false,
      },
   },
   data() {
      return {
         loading: false,
         form: {
            oss_scrap_filter_lokasi: 'awal',
         },
      }
   },
   watch: {
      value(visible) {
         if (visible) {
            this.loadData()
         }
      },
   },
   methods: {
      ...mapActions({
         getOssSetting: 'Pengaturan/getOssSetting',
         saveOssSetting: 'Pengaturan/saveOssSetting',
      }),
      loadData() {
         this.loading = true
         this.getOssSetting().then(res => {
            if (res && res.value) {
               this.form.oss_scrap_filter_lokasi = res.value
            }
            this.loading = false
         }, () => {
            this.loading = false
         })
      },
      onSave() {
         this.loading = true
         this.saveOssSetting(this.form).then(() => {
            this.loading = false
            this.$toast.success('Konfigurasi berhasil disimpan.')
            this.$emit('input', false)
            this.$emit('saved', this.form)
         }, () => {
            this.loading = false
            this.$toast.error('Gagal menyimpan konfigurasi.')
         })
      },
      close() {
         this.$emit('input', false)
         this.$emit('close')
      },
   },
}
</script>

<template>
   <b-modal
      :visible="value"
      centered
      title="Konfigurasi"
      no-close-on-backdrop
      hide-header-close
      @hide="close"
   >
      <b-form @submit.stop.prevent="onSave">
         <b-form-group label="Filter Lokasi" label-for="oss_scrap_filter_lokasi">
            <b-form-radio-group
               id="oss_scrap_filter_lokasi"
               v-model="form.oss_scrap_filter_lokasi"
               name="oss_scrap_filter_lokasi"
               stacked
            >
               <b-form-radio value="awal">
                  Awal
               </b-form-radio>
               <b-form-radio value="akhir">
                  Akhir (Proses lebih lama, tapi lebih akurat)
               </b-form-radio>
            </b-form-radio-group>
         </b-form-group>
      </b-form>
      <template #modal-footer>
         <b-button variant="secondary" :disabled="loading" @click="close">
            Close
         </b-button>
         <b-button variant="primary" :disabled="loading" @click="onSave">
            <b-spinner v-if="loading" small />
            <feather-icon v-if="!loading" icon="SaveIcon" class="mr-50" />
            Simpan
         </b-button>
      </template>
   </b-modal>
</template>

<style scoped></style>
